// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnIE7wanAFTiz3pxJ8NC {
	align-items: center;
	background: var(--white);
	border-radius: 12px;
	border: none;
	box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);
	cursor: pointer;
	display: flex;
	height: 40px;
	justify-content: center;
	outline: none;
	padding: 0;
	width: 40px;
}
`, "",{"version":3,"sources":["webpack://./src/components/IconButton/IconButton.pcss"],"names":[],"mappings":"AAAA;CACC,mBAAmB;CACnB,wBAAwB;CACxB,mBAAmB;CACnB,YAAY;CACZ,4CAA4C;CAC5C,eAAe;CACf,aAAa;CACb,YAAY;CACZ,uBAAuB;CACvB,aAAa;CACb,UAAU;CACV,WAAW;AACZ","sourcesContent":[".container {\n\talign-items: center;\n\tbackground: var(--white);\n\tborder-radius: 12px;\n\tborder: none;\n\tbox-shadow: 0px 4px 16px rgba(0, 0, 0, 0.04);\n\tcursor: pointer;\n\tdisplay: flex;\n\theight: 40px;\n\tjustify-content: center;\n\toutline: none;\n\tpadding: 0;\n\twidth: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `UnIE7wanAFTiz3pxJ8NC`
};
export default ___CSS_LOADER_EXPORT___;
